module.exports = __webpack_public_path__ + "img/features-maintain.3698976e.svg";